// @flow

import * as React from 'react';
import {Executable} from './_executable';
import {search, relativePath, Pages} from '../helpers/executables/docs_navtree';

const PrintDirectory = (props: {currentPath: string}): React.Node => {
  const {currentPath} = props;

  const currentPage = search(currentPath, Pages());
  if (currentPage == null) {
    return <p>Error, something went wrong.</p>;
  }

  // Get the entire relative path
  const path = relativePath(currentPage);

  return (
    <p>
      {path} -- {currentPage.title}
    </p>
  );
};

export class pwd extends Executable {
  commandName(): string {
    return 'pwd';
  }

  shortHelp(): string {
    return 'prints the current page slug and title';
  }

  help() {
    this.setAllowInput(true);
    return (
      <p>
        pwd prints the current page. The first value is the page slug that can
        <br />
        be used with cd or ls. The second is the title of the page itself for
        <br />
        reference.
      </p>
    );
  }

  run() {
    this.setAllowInput(true);
    return <PrintDirectory currentPath={window.location.pathname} />;
  }
}
